import { View } from "@/components/ui/view";
import { ScrollView } from "react-native-gesture-handler";
import { VStack } from "@/components/ui/vstack";
import { Text } from "@/components/ui/text";
import React from 'react';
import Footer from "../../components/basic/Footer";
import { useSafeAreaInsets } from "react-native-safe-area-context";

export default function Imprint({ navigation, hideFooter }) {
    const insets = useSafeAreaInsets()

    return (
        <View className="flex-1 bg-secondary-50">
            <ScrollView contentContainerStyle={{ paddingBottom: 50 + insets.bottom }}>
                <VStack space='xs' className="flex-1 px-6 py-3 bg-secondary-50">
                    <Text bold className="text-xl leading-xl text-secondary-900">{'Angaben gemäß § 5 TMG'}</Text>
                    <Text className="text-black font-[400] text-lg">
                        {'BOS Connect GmbH\nAckergasse 4\nD-73525 Schwäbisch Gmünd\n\nHandelsregister: 729 882\nRegistergericht: Amtsgericht Ulm'}
                    </Text>
                    <Text bold className="text-xl leading-xl text-secondary-900">{'Vertreten durch:'}</Text>
                    <Text className="text-black font-[400] text-lg">
                        {'Gero A. Nicklas\nMichael Fritz'}
                    </Text>
                    <Text bold className="text-xl leading-xl text-secondary-900">{'Kontakt'}</Text>
                    <Text className="text-black font-[400] text-lg">
                        {'[ fon ] +49 7171 40 44 980\n[ fax ] +49 7171 40 44 981\n[ mail ] info@bos-connect.de\n[ web ] www.bos-connect.de'}
                    </Text>
                    <Text bold className="text-xl leading-xl text-secondary-900">{'Umsatzsteuer-ID'}</Text>
                    <Text className="text-black font-[400] text-lg">
                        {'Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:\nDE 291 789 846'}
                    </Text>
                    <Text bold className="text-xl leading-xl text-secondary-900">{'Redaktionell verantwortlich'}</Text>
                    <Text className="text-black font-[400] text-lg">
                        {'Gero Nicklas\nAckergasse 4\n73525 Schwäbisch Gmünd'}
                    </Text>
                    <Text bold className="text-xl leading-xl text-secondary-900">{'EU-Streitschlichtung'}</Text>
                    <Text className="text-black font-[400] text-lg">
                        {'Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: https://ec.europa.eu/consumers/odr/.\nUnsere E-Mail-Adresse finden Sie oben im Impressum.'}
                    </Text>
                    <Text bold className="text-xl leading-xl text-secondary-900">{'Verbraucherstreitbeilegung/Universalschlichtungsstelle'}</Text>
                    <Text className="text-black font-[400] text-lg">
                        {'Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.'}
                    </Text>
                </VStack >
            </ScrollView>
            {!hideFooter && <Footer navigation={navigation}/>}
        </View>
    );
}